



































import EmojiPickerVue from "./emojiPickerVue.vue";
import uploadFiles from "@/mixins/uploadFiles";
import attachmentsSnackbarAlert from "../components/attachments/attachmentsSnackbarAlert.vue";
import attachmentsUploadPreview from "../components/attachments/attachmentsUploadPreview.vue";
export default {
    components: {
        EmojiPickerVue,
        attachmentsUploadPreview,
        attachmentsSnackbarAlert
    },
    props: ['disconnected', 'hideMic', 'initMessage', 'isFullScreen'],
    mixins: [uploadFiles],
    computed: {
        uploadingAttachmentsInProgress() {
            return this.$vstore.Attachments.state.uploadingAttachmentsInProgress;
        },
        disabledSendButton() {
            return this.uploadingAttachmentsInProgress || this.disconnected;
        }
    },
    data() {
        return {
            newMessage: this.initMessage || "",
            sendImage: false,
            imageData: "",
            confidenceList: [10, 90, 60],
            voiceMode: false,
            WhiteLabelUrl: 'https://res.cloudinary.com/tactful/image/upload/v1622640081/tactful_logo_1_mtlklq.svg',
            fileInputAccept: null,
            dragInProgress: false,
            files: [],
            maxFileSize: null,
            showFileSizeValidation: false,
            showFileTypeValidation: false,
            showMaxFilesValidation: false,
            showUploadFilesError: false,
            validitionShowTimeout: 3000,
            maxFilesToUpload: 4,
            fileIsNotSupported: null,
            getValidationSettingFailed: false
        };
    },
    watch: {
        initMessage: function (val) {
            this.newMessage = val;
        }
    },
    methods: {
        sendMessage() {
            if (this.disconnected) return;
            //prevent fire action if attachments still uploading
            if (this.$vstore.Attachments.state.uploadingAttachmentsInProgress) return;
            if (this.sendImage) {
                this.newMessage =
                    `<span class="fas fa-image" v-if="sendImage"> &nbsp;` + this.newMessage;
            }
            else {
                this.$emit("sendMessage", this.newMessage);
                this.newMessage = "";
                this.sendImage = false;
                this.handleAttachmentsAfterSend();
            }
        },
        append(emoji: string) {
            if (this.disconnected) return;
            this.newMessage += emoji;
        },
        inputHandler(e: any) {
            if (this.disconnected) return;
            if (e.keyCode === 13 && !e.shiftKey) {
                if (!this.newMessage || this.newMessage.trim().length == 0) {
                    return;
                }
                else {
                    e.preventDefault();
                    this.sendMessage();
                }
            }
        },
        togglevoiceMode() {
            if (this.disconnected) return;
            this.voiceMode = true;
            this.$emit("togglevoiceMode", this.voiceMode);
        },
        resetUnreadCount() {
            if (this.disconnected) return;
            this.$emit("resetUnreadCount");
        },
        onFileInputChange(event: any) {
            if (this.disconnected) return;
            this.onChange(event);
            this.$emit("onFileInputChange", this.files);
        },
        dragenter(e: any) {
            e.preventDefault();
            if (this.disconnected || !this.$refs.dragZone) return;
            if (this.$refs.dragZone.classList?.contains('tc--b-widget__input-drop-zone--show')) return;
            this.$refs.dragZone.classList?.add('tc--b-widget__input-drop-zone--show');
        },
        dragleave(e: any) {
            e.preventDefault();
            if (this.disconnected || !this.$refs.dragZone) return;
            this.$refs.dragZone.classList?.remove('tc--b-widget__input-drop-zone--show');
        },
        drop(e: any) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (this.disconnected) return;
            if (this.$refs.dragZone) {
                this.$refs.dragZone.classList?.remove('tc--b-widget__input-drop-zone--show');
            }
            this.$refs.tactfulFiles.files = e.dataTransfer.files;
            this.onChange(e);
        }
    }
};
